import { useState, useEffect } from "react";

import colors from "assets/theme/base/colors";
import VuiInput from "components/VuiInput";
import { IoIosSearch } from "react-icons/io";
import { IoMdClose } from "react-icons/io";

import { Container } from "./styles";

function SearchItem({ onClick = () => {}, onChange = () => {}, onReset = () => {} }) {
  const [txtSearch, SetTxtSearch] = useState("");
  return (
    <Container>
      <VuiInput
        value={txtSearch}
        name="email"
        placeholder="Digite o nome do computador"
        onChange={(e) => {
          const value = e.target.value;
          if (value.length > 0) {
            SetTxtSearch(value);
            // onChange(value);
          } else {
            SetTxtSearch("");
            onReset();
          }
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.keyCode === 13) onClick(txtSearch);
        }}
      />

      {txtSearch.length === 0 ? (
        <IoIosSearch
          style={{ marginLeft: 10, cursor: "pointer" }}
          onClick={() => onClick(txtSearch)}
        />
      ) : (
        <IoMdClose
          style={{ marginLeft: 10, cursor: "pointer" }}
          onClick={() => {
            SetTxtSearch("");
            onReset();
          }}
        />
      )}
    </Container>
  );
}

export default SearchItem;
